import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getOrders, updateOrderStatus, deleteOrder, deleteProduct } from '../api';
import { getImageUrl } from '../utils';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 
  (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1'
    ? '/api'
    : 'http://localhost:5000/api');

function AdminPanel() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [filterStatus, setFilterStatus] = useState('');
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [loginData, setLoginData] = useState({ username: '', password: '' });
  const [loginError, setLoginError] = useState('');
  
  // Состояние для добавления товара
  const [showAddProduct, setShowAddProduct] = useState(false);
  const [products, setProducts] = useState([]);
  const [newProduct, setNewProduct] = useState({
    name: '',
    description: '',
    price: '',
    category: 'roses',
    composition: '',
    dimensions: '',
    flowerCount: '',
    inStock: true
  });
  const [productImages, setProductImages] = useState([]);
  const [productImagesPreview, setProductImagesPreview] = useState([]);
  const [savingProduct, setSavingProduct] = useState(false);

  const statusLabels = {
    'new': 'Новый',
    'processing': 'В обработке',
    'delivered': 'Доставлен',
    'cancelled': 'Отменен'
  };

  const statusColors = {
    'new': '#4CAF50',
    'processing': '#FF9800',
    'delivered': '#2196F3',
    'cancelled': '#f44336'
  };

  const categories = [
    { value: 'roses', label: '🌹 Розы' },
    { value: 'peonies', label: '🌸 Пионы' },
    { value: 'tulips', label: '🌷 Тюльпаны' },
    { value: 'bouquets', label: '💐 Авторские букеты' }
  ];

  useEffect(() => {
    if (authenticated) {
      loadOrders();
      loadProducts();
    }
  }, [filterStatus, authenticated]);

  const loadOrders = async () => {
    setLoading(true);
    const data = await getOrders(filterStatus || null);
    setOrders(data);
    setLoading(false);
  };

  const loadProducts = async () => {
    try {
      const response = await axios.get(`${API_URL}/products`);
      setProducts(response.data);
    } catch (error) {
      console.error('Error loading products:', error);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (loginData.username === 'admin' && loginData.password === 'admin123') {
      setAuthenticated(true);
      setLoginError('');
    } else {
      setLoginError('Неверное имя пользователя или пароль');
    }
  };

  const handleStatusChange = async (orderId, newStatus) => {
    try {
      await updateOrderStatus(orderId, newStatus);
      loadOrders();
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  const handleDeleteOrder = async (orderId) => {
    if (window.confirm('Вы уверены, что хотите удалить этот заказ?')) {
      try {
        await deleteOrder(orderId);
        loadOrders();
      } catch (error) {
        console.error('Error deleting order:', error);
      }
    }
  };

  // Обработчики для формы товара
  const handleProductChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewProduct({
      ...newProduct,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files).slice(0, 3); // Максимум 3 фото
    setProductImages(files);
    
    // Создаем превью изображений
    const previews = files.map(file => URL.createObjectURL(file));
    setProductImagesPreview(previews);
  };

  const handleAddProduct = async (e) => {
    e.preventDefault();
    setSavingProduct(true);

    try {
      const formData = new FormData();
      formData.append('name', newProduct.name);
      formData.append('description', newProduct.description);
      formData.append('price', newProduct.price);
      formData.append('category', newProduct.category);
      formData.append('composition', newProduct.composition || '');
      formData.append('dimensions', newProduct.dimensions || '');
      formData.append('flowerCount', newProduct.flowerCount || '0');
      formData.append('inStock', newProduct.inStock.toString());

      // Добавляем изображения
      productImages.forEach(image => {
        formData.append('images', image);
      });

      console.log('Sending product data:', {
        name: newProduct.name,
        price: newProduct.price,
        category: newProduct.category,
        imagesCount: productImages.length
      });

      const response = await axios.post(`${API_URL}/products`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        timeout: 30000
      });

      console.log('Product created:', response.data);

      // Сброс формы
      setNewProduct({
        name: '',
        description: '',
        price: '',
        category: 'roses',
        composition: '',
        dimensions: '',
        flowerCount: '',
        inStock: true
      });
      setProductImages([]);
      setProductImagesPreview([]);
      
      await loadProducts();
      setShowAddProduct(false);
      alert('✓ Товар успешно добавлен!');
    } catch (error) {
      console.error('Error adding product:', error);
      const errorMessage = error.response?.data?.message || error.message || 'Неизвестная ошибка';
      alert(`Ошибка при добавлении товара:\n${errorMessage}\n\nПроверьте, что backend запущен на порту 5000`);
    } finally {
      setSavingProduct(false);
    }
  };

  const handleDeleteProduct = async (productId) => {
    if (window.confirm('Вы уверены, что хотите удалить этот товар?')) {
      try {
        await deleteProduct(productId);
        await loadProducts();
        alert('Товар удален');
      } catch (error) {
        console.error('Error deleting product:', error);
        alert('Ошибка при удалении товара');
      }
    }
  };

  if (!authenticated) {
    return (
      <div className="admin-login">
        <div className="login-form">
          <h2>Вход в панель администратора</h2>
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="username">Имя пользователя</label>
              <input
                type="text"
                id="username"
                value={loginData.username}
                onChange={(e) => setLoginData({ ...loginData, username: e.target.value })}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Пароль</label>
              <input
                type="password"
                id="password"
                value={loginData.password}
                onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
                required
              />
            </div>
            {loginError && <div className="error-message">{loginError}</div>}
            <button type="submit" className="login-button">Войти</button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-panel">
      <div className="admin-header">
        <h1>Панель администратора</h1>
        <div className="admin-header-buttons">
          <button onClick={() => setShowAddProduct(!showAddProduct)} className="add-product-button">
            {showAddProduct ? '✕ Закрыть' : '＋ Добавить товар'}
          </button>
          <button onClick={() => setAuthenticated(false)} className="logout-button">
            Выйти
          </button>
        </div>
      </div>

      {/* Форма добавления товара */}
      {showAddProduct && (
        <div className="add-product-form">
          <h2>Добавить новый товар</h2>
          <form onSubmit={handleAddProduct}>
            <div className="product-form-grid">
              <div className="form-group">
                <label htmlFor="name">Название товара *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={newProduct.name}
                  onChange={handleProductChange}
                  required
                  placeholder="Например: Букет из 25 роз"
                />
              </div>

              <div className="form-group">
                <label htmlFor="price">Цена (₽) *</label>
                <input
                  type="number"
                  id="price"
                  name="price"
                  value={newProduct.price}
                  onChange={handleProductChange}
                  required
                  min="0"
                  placeholder="3500"
                />
              </div>

              <div className="form-group">
                <label htmlFor="category">Категория *</label>
                <select
                  id="category"
                  name="category"
                  value={newProduct.category}
                  onChange={handleProductChange}
                  required
                >
                  {categories.map(cat => (
                    <option key={cat.value} value={cat.value}>{cat.label}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="flowerCount">Количество цветов/штук</label>
                <input
                  type="number"
                  id="flowerCount"
                  name="flowerCount"
                  value={newProduct.flowerCount}
                  onChange={handleProductChange}
                  min="0"
                  placeholder="25"
                />
              </div>

              <div className="form-group full-width">
                <label htmlFor="description">Описание *</label>
                <textarea
                  id="description"
                  name="description"
                  value={newProduct.description}
                  onChange={handleProductChange}
                  required
                  rows="3"
                  placeholder="Подробное описание товара..."
                />
              </div>

              <div className="form-group">
                <label htmlFor="composition">Состав</label>
                <input
                  type="text"
                  id="composition"
                  name="composition"
                  value={newProduct.composition}
                  onChange={handleProductChange}
                  placeholder="Розы, зелень, упаковка"
                />
              </div>

              <div className="form-group">
                <label htmlFor="dimensions">Размеры</label>
                <input
                  type="text"
                  id="dimensions"
                  name="dimensions"
                  value={newProduct.dimensions}
                  onChange={handleProductChange}
                  placeholder="Высота: ~60 см"
                />
              </div>

              <div className="form-group full-width">
                <label htmlFor="images">Изображения (до 3 фото)</label>
                <input
                  type="file"
                  id="images"
                  name="images"
                  multiple
                  accept="image/*"
                  onChange={handleImageChange}
                  className="file-input"
                />
                <p className="file-hint">Поддерживаемые форматы: JPG, PNG, GIF (макс. 5MB)</p>
              </div>

              {/* Превью изображений */}
              {productImagesPreview.length > 0 && (
                <div className="image-preview-grid">
                  {productImagesPreview.map((preview, index) => (
                    <div key={index} className="image-preview-item">
                      <img src={preview} alt={`Preview ${index + 1}`} />
                    </div>
                  ))}
                </div>
              )}

              <div className="form-group checkbox-group">
                <input
                  type="checkbox"
                  id="inStock"
                  name="inStock"
                  checked={newProduct.inStock}
                  onChange={handleProductChange}
                />
                <label htmlFor="inStock">В наличии</label>
              </div>
            </div>

            <button type="submit" className="submit-product-button" disabled={savingProduct}>
              {savingProduct ? 'Сохранение...' : 'Добавить товар'}
            </button>
          </form>
        </div>
      )}

      {/* Список товаров */}
      {products.length > 0 && (
        <div className="products-admin-section">
          <h2>Товары ({products.length})</h2>
          <div className="products-admin-grid">
            {products.map(product => (
              <div key={product.id} className="product-admin-card">
                <div className="product-admin-image">
                  {product.images && product.images.length > 0 ? (
                    <img src={getImageUrl(product.images[0])} alt={product.name} />
                  ) : (
                    <span className="product-emoji">{product.image}</span>
                  )}
                </div>
                <div className="product-admin-info">
                  <h4>{product.name}</h4>
                  <p className="product-admin-price">{product.price.toLocaleString()} ₽</p>
                  <p className="product-admin-category">
                    {product.category === 'roses' && 'Розы'}
                    {product.category === 'peonies' && 'Пионы'}
                    {product.category === 'tulips' && 'Тюльпаны'}
                    {product.category === 'bouquets' && 'Авторские букеты'}
                  </p>
                  <button 
                    onClick={() => handleDeleteProduct(product.id)}
                    className="delete-product-button"
                  >
                    Удалить
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Фильтры заказов */}
      <div className="admin-filters">
        <button
          className={`filter-button ${filterStatus === '' ? 'active' : ''}`}
          onClick={() => setFilterStatus('')}
        >
          Все заказы
        </button>
        <button
          className={`filter-button ${filterStatus === 'new' ? 'active' : ''}`}
          onClick={() => setFilterStatus('new')}
        >
          Новые
        </button>
        <button
          className={`filter-button ${filterStatus === 'processing' ? 'active' : ''}`}
          onClick={() => setFilterStatus('processing')}
        >
          В обработке
        </button>
        <button
          className={`filter-button ${filterStatus === 'delivered' ? 'active' : ''}`}
          onClick={() => setFilterStatus('delivered')}
        >
          Доставлены
        </button>
        <button
          className={`filter-button ${filterStatus === 'cancelled' ? 'active' : ''}`}
          onClick={() => setFilterStatus('cancelled')}
        >
          Отменены
        </button>
      </div>

      {/* Список заказов */}
      {loading ? (
        <div className="loading">Загрузка заказов...</div>
      ) : orders.length === 0 ? (
        <div className="no-orders">Заказы не найдены</div>
      ) : (
        <div className="orders-list">
          {orders.map(order => (
            <div key={order.id} className="order-card">
              <div className="order-header">
                <h3>Заказ #{order.orderNumber}</h3>
                <span
                  className="order-status"
                  style={{ backgroundColor: statusColors[order.status] }}
                >
                  {statusLabels[order.status]}
                </span>
              </div>

              <div className="order-info">
                <div className="order-info-row">
                  <strong>Клиент:</strong> {order.customerName}
                </div>
                <div className="order-info-row">
                  <strong>Telegram:</strong> {order.telegram || 'Не указан'}
                </div>
                <div className="order-info-row">
                  <strong>Город:</strong> {order.city}
                </div>
                <div className="order-info-row">
                  <strong>Адрес:</strong> {order.address}
                </div>
                {order.wishes && (
                  <div className="order-info-row">
                    <strong>Пожелания:</strong> {order.wishes}
                  </div>
                )}
                <div className="order-info-row">
                  <strong>Дата:</strong> {new Date(order.createdAt).toLocaleString('ru-RU')}
                </div>
              </div>

              <div className="order-items">
                <h4>Товары:</h4>
                {order.items.map((item, index) => (
                  <div key={index} className="order-item">
                    <div className="order-item-info">
                      <span className="order-item-name">{item.name}</span>
                      <span className="order-item-price">{item.price.toLocaleString()} ₽ x {item.quantity}</span>
                    </div>
                    {item.productId && (
                      <button
                        className="view-product-button"
                        onClick={() => navigate(`/product/${item.productId}`)}
                      >
                        🔗 Перейти к товару
                      </button>
                    )}
                  </div>
                ))}
              </div>

              <div className="order-total">
                <strong>Итого: {order.totalAmount.toLocaleString()} ₽</strong>
              </div>

              <div className="order-actions">
                <select
                  value={order.status}
                  onChange={(e) => handleStatusChange(order.id, e.target.value)}
                  className="status-select"
                >
                  <option value="new">Новый</option>
                  <option value="processing">В обработке</option>
                  <option value="delivered">Доставлен</option>
                  <option value="cancelled">Отменен</option>
                </select>
                <button
                  onClick={() => handleDeleteOrder(order.id)}
                  className="delete-button"
                >
                  Удалить
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default AdminPanel;
